import app from "flarum/forum/app";
import {extend, override} from 'flarum/common/extend';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import classList from 'flarum/common/utils/classList';
import TagDiscussionModal from 'flarum/tags/components/TagDiscussionModal';
import getSelectableTags from 'flarum/tags/utils/getSelectableTags';
import ProductDiscussionModal from '../components/ProductDiscussionModal';

/**
 *  发帖编辑器
 */
export default function composerContent() {
  extend(DiscussionComposer.prototype, 'oninit', function () {
    app.productList.load().then(() => m.redraw());
  });

  DiscussionComposer.prototype.chooseProducts = function () {
    app.modal.show(ProductDiscussionModal, {
      // canSelectMultiple: true,
      selectedProducts: (this.composer.fields.products || []).slice(0),
      onsubmit: (products) => {
        this.composer.fields.products = products;
        this.$('textarea').focus();
      },
    });
  };

  extend(DiscussionComposer.prototype, 'productItems', function (items) {
    const products = this.composer.fields.products || [];

    items.add(
      'products',
      <a className={classList(['DiscussionComposer-changeProducts'])} onclick={this.chooseProducts.bind(this)}>
        {products.length ? (
          <span className="Products-label">
            {products.map((product) => (
              <span className="Products-label-item">{product?.name()}</span>
            ))}
          </span>
        ) : (
          <span className="TagLabel untagged">{app.translator.trans('acme-ruko.forum.product.select_product')}</span>
        )}
      </a>,
      10
    );
  });

  extend(DiscussionComposer.prototype, 'data', function (data) {
    const product = this.composer.fields.products?.[0]?.id();
    data.product_id = product || '';
  });

  override(DiscussionComposer.prototype, 'onsubmit', function (original) {
    const chosenTags = this.composer.fields.tags || [];
    const chosenPrimaryTags = chosenTags.filter((tag) => tag.position() !== null && !tag.isChild());
    const chosenSecondaryTags = chosenTags.filter((tag) => tag.position() === null);
    const selectableTags = getSelectableTags();

    const minPrimaryTags = parseInt(app.forum.attribute('minPrimaryTags'));
    const minSecondaryTags = parseInt(app.forum.attribute('minSecondaryTags'));
    const maxPrimaryTags = parseInt(app.forum.attribute('maxPrimaryTags'));
    const maxSecondaryTags = parseInt(app.forum.attribute('maxSecondaryTags'));

    const productTags = app.forum.attribute('product_selected_tag') || [];
    const products = this.composer.fields.products || [];
    const ids = chosenTags?.map(item => item?.data?.id);
    const isProduct = ids?.some(tag => productTags?.includes(tag));

    if (
      ((!chosenTags.length && maxPrimaryTags !== 0 && maxSecondaryTags !== 0) ||
        chosenPrimaryTags.length < minPrimaryTags ||
        chosenSecondaryTags.length < minSecondaryTags) &&
      selectableTags.length
    ) {
      app.modal.show(TagDiscussionModal, {
        selectedTags: chosenTags,
        onsubmit: (tags) => {
          this.composer.fields.tags = tags;
        },
      });
    } else if(isProduct && !products.length) {
      app.modal.show(ProductDiscussionModal, {
        // canSelectMultiple: true,
        selectedProducts: (this.composer.fields.products || []).slice(0),
        onsubmit: (products) => {
          this.composer.fields.products = products;
        },
      });
    } else {
      original();
    }
  });
}
